module.exports = __webpack_public_path__ + "assets/img/dzh-7.a08ba4a7.jpg";